import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import StudioHeading from '../../../StudioHeading';
import DraftsTabs from '../../../drafts/DraftsTabs';
import SimpleUploadButton from '../../../SimpleUploadButton';
import { getIsUploadPage } from '../../../../selectors/studio';
import BaseHeader from '../BaseHeader';

interface Props {
  className?: string;
}

const DraftsHeader: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const canUpload = useSelector(getIsUploadPage);

  return (
    <BaseHeader
      className={className}
      titleSlot={
        <>
          <StudioHeading>{t('studio.header.tabs.drafts')}</StudioHeading>
          <DraftsTabs />
        </>
      }
      actions={<SimpleUploadButton label={t('studio.header.upload')} linkToSubmit={!canUpload} />}
    />
  );
};

DraftsHeader.displayName = 'DraftsHeader';

export default DraftsHeader;
